webpackJsonp([18],{

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(545)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(572),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-20cfca5b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MassRemoveModal",
  props: ['data', 'taxCategories', 'selectedCompanyInfo', 'views', 'viewsTree', 'printCategoriesTree'],
  data: function data() {
    return {
      language: this.$cookie.get('lang') || 'en',
      languages: [{
        text: "English",
        value: "en"
      }, {
        text: "German",
        value: "de"
      }, {
        text: "Chinese",
        value: "zh"
      }],
      size: {
        en: '',
        de: '',
        zh: '',
        price: '',
        isDefault: false
      },
      variant: {
        en: '',
        de: '',
        zh: '',
        price: '',
        isDefault: false
      },
      style: {
        en: '',
        de: '',
        zh: '',
        isDefault: false
      },
      option: {
        en: '',
        de: '',
        zh: '',
        price: '',
        isDefault: false
      },
      types: [
      // {name: 'Tax Category', value: 'taxCategory'},
      // {name: 'VAT', value: 'vatRate'},
      { name: 'Views', value: 'views' }, { name: 'Printer Categories', value: 'printerCategories' }],
      taxCategory: 'standard',
      type: null,
      vatRate: null,
      viewsClone: [],
      err: '',
      printerCategories: ['LABEL', 'KITCHEN1', 'KITCHEN2', 'KITCHEN3', 'KITCHEN4', 'KITCHEN5', 'BAR1', 'BAR2', 'BAR3', 'BAR4', 'BAR5', 'SALAD1', 'SALAD2', 'SALAD3', 'SALAD4', 'SALAD5'],
      catalogPrinters: [],
      settings: [{ name: 'Label Print', value: 'labelPrint', selected: false }, { name: 'Ask details', value: 'askDetails', selected: false }, { name: 'VAT print', value: 'vatPrint', selected: false }, { name: 'No discount', value: 'noDiscount', selected: false }, { name: 'Adds Galaxy Card balance', value: 'galaxyCardBalance', selected: false }]
    };
  },

  computed: {
    label: function label() {
      var _this = this;

      return this.types.filter(function (type) {
        return type.value === _this.type;
      })[0].name || 'Value';
    },
    vatItems: function vatItems() {
      return this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0 ? [{
        text: 'Not selected',
        value: null
      }].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.selectedCompanyInfo.vatRates.map(function (vatRateItem) {
        return {
          text: '' + vatRateItem,
          value: '' + vatRateItem
        };
      }))) : [{ value: 'null', text: 'null' }];
    }
  },
  watch: {
    err: function err(val) {
      var _this2 = this;

      if (val !== '') {
        setTimeout(function () {
          _this2.err = '';
        }, 5000);
      }
    }
  },
  created: function created() {
    var _this3 = this;

    var viewClone = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.viewsTree));
    this.viewsClone = viewClone.map(function (x) {
      var fullView = _this3.views.find(function (y) {
        return y.viewId === x;
      });
      fullView.selected = false;
      return fullView;
    });
    this.catalogPrinters = this.printCategoriesTree.map(function (current) {
      return {
        name: current,
        selected: false
      };
    });
  },

  methods: {
    submitMassRemove: function submitMassRemove() {
      if (!this.type) {
        this.err = 'You must select Remove type!';
        return;
      }
      if (this.type === 'taxCategory' && this.taxCategory === '') {
        this.err = 'Tax category cannot be empty!';
        return;
      }
      if (this.type === 'vatRate' && this.vatRate === '') {
        this.err = 'VAT rate cannot be empty!';
        return;
      }
      if (this.type === 'sizes' && this.size[this.selectedCompanyInfo.defaultLanguage] === '') {
        this.err = 'Size in default language cannot be empty!';
        return;
      }
      if (this.type === 'sizes' && this.size.price === '') {
        this.err = 'Size needs to have price!';
        return;
      }
      var submitObj = {};
      submitObj.type = this.type;
      submitObj.item = this.data;
      if (this.type === 'taxCategory') {
        submitObj.value = this.taxCategory;
      }
      if (this.type === 'vatRate') {
        submitObj.value = this.vatRate;
      }
      if (this.type === 'views') {
        submitObj.value = this.viewsClone.map(function (x) {
          if (x.selected) return x.viewId;
        });
        submitObj.value = submitObj.value.filter(function (el) {
          return el != null;
        });
      }
      if (this.type === 'printerCategories') {
        submitObj.value = this.catalogPrinters.map(function (x) {
          if (x.selected) return x.name;
        });
        submitObj.value = submitObj.value.filter(function (el) {
          return el != null;
        });
      }
      if (this.type === 'settings') {
        submitObj.value = this.settings.map(function (x) {
          if (x.selected) return x.value;
        });
      }
      if (this.type === 'sizes') {
        submitObj.value = this.size;
      }
      if (this.type === 'variants') {
        submitObj.value = this.variant;
      }
      if (this.type === 'styles') {
        submitObj.value = this.style;
      }
      if (this.type === 'options') {
        submitObj.value = this.option;
      }
      this.$emit('submit', submitObj);
    }
  }
});

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"MassRemoveModal.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(519);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("2ade4968", content, true, {});

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": "",
      "pb-3": ""
    }
  }, [_c('h2', [_vm._v("Mass remove")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Remove type",
      "items": _vm.types,
      "item-text": "name",
      "item-value": "value",
      "hide-details": ""
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "px-2": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.type === 'taxCategory') ? _c('v-combobox', {
    attrs: {
      "label": _vm.label,
      "items": _vm.taxCategories
    },
    nativeOn: {
      "input": function($event) {
        return (function (e) { return _vm.taxCategory = e.target.value; })($event)
      }
    },
    model: {
      value: (_vm.taxCategory),
      callback: function($$v) {
        _vm.taxCategory = $$v
      },
      expression: "taxCategory"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.type === 'vatRate') ? _c('v-select', {
    staticClass: "pt-2",
    attrs: {
      "items": _vm.vatItems,
      "disabled": !this.selectedCompanyInfo.vatRates || this.selectedCompanyInfo.vatRates.length === 0 ? true : false
    },
    model: {
      value: (_vm.vatRate),
      callback: function($$v) {
        _vm.vatRate = $$v
      },
      expression: "vatRate"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "py-4": "",
      "px-2": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'views') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, _vm._l((_vm.viewsClone), function(view, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "label": view.name[_vm.language]
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (view.selected),
        callback: function($$v) {
          _vm.$set(view, "selected", $$v)
        },
        expression: "view.selected"
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'printerCategories') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, _vm._l((_vm.catalogPrinters), function(printer, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "label": printer.name
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (printer.selected),
        callback: function($$v) {
          _vm.$set(printer, "selected", $$v)
        },
        expression: "printer.selected"
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'settings') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, _vm._l((_vm.settings), function(setting, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "label": setting.name
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (setting.selected),
        callback: function($$v) {
          _vm.$set(setting, "selected", $$v)
        },
        expression: "setting.selected"
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'sizes') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "EN Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.size.en),
      callback: function($$v) {
        _vm.$set(_vm.size, "en", $$v)
      },
      expression: "size.en"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "DE Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.size.de),
      callback: function($$v) {
        _vm.$set(_vm.size, "de", $$v)
      },
      expression: "size.de"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ZH Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.size.zh),
      callback: function($$v) {
        _vm.$set(_vm.size, "zh", $$v)
      },
      expression: "size.zh"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Price"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.size.price),
      callback: function($$v) {
        _vm.$set(_vm.size, "price", $$v)
      },
      expression: "size.price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Set as Default"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.size.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.size, "isDefault", $$v)
      },
      expression: "size.isDefault"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'variants') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "EN Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.variant.en),
      callback: function($$v) {
        _vm.$set(_vm.variant, "en", $$v)
      },
      expression: "variant.en"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "DE Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.variant.de),
      callback: function($$v) {
        _vm.$set(_vm.variant, "de", $$v)
      },
      expression: "variant.de"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ZH Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.variant.zh),
      callback: function($$v) {
        _vm.$set(_vm.variant, "zh", $$v)
      },
      expression: "variant.zh"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Price"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.variant.price),
      callback: function($$v) {
        _vm.$set(_vm.variant, "price", $$v)
      },
      expression: "variant.price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Set as Default"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.variant.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.variant, "isDefault", $$v)
      },
      expression: "variant.isDefault"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'options') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "EN Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.option.en),
      callback: function($$v) {
        _vm.$set(_vm.option, "en", $$v)
      },
      expression: "option.en"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "DE Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.option.de),
      callback: function($$v) {
        _vm.$set(_vm.option, "de", $$v)
      },
      expression: "option.de"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ZH Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.option.zh),
      callback: function($$v) {
        _vm.$set(_vm.option, "zh", $$v)
      },
      expression: "option.zh"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Price"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.option.price),
      callback: function($$v) {
        _vm.$set(_vm.option, "price", $$v)
      },
      expression: "option.price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Set as Default"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.option.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.option, "isDefault", $$v)
      },
      expression: "option.isDefault"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'styles') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "EN Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.style.en),
      callback: function($$v) {
        _vm.$set(_vm.style, "en", $$v)
      },
      expression: "style.en"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "DE Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.style.de),
      callback: function($$v) {
        _vm.$set(_vm.style, "de", $$v)
      },
      expression: "style.de"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ZH Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.style.zh),
      callback: function($$v) {
        _vm.$set(_vm.style, "zh", $$v)
      },
      expression: "style.zh"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Set as Default"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.style.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.style, "isDefault", $$v)
      },
      expression: "style.isDefault"
    }
  })], 1)], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitMassRemove()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.f6b4f9ed61cd2860c4b5.js